import { tsParticles as i } from "@tsparticles/engine";
import o from "./Particles.js";
import "react/jsx-runtime";
import "react";
async function n(t) {
  await t(i);
}
export {
  o as Particles,
  o as default,
  n as initParticlesEngine
};
